export default "__VITE_ASSET__BlF0et$o__"